class GetEtoByIntervalUseCase {
  constructor(repository) {
    this.repository = repository;
  }
  async execute(START,END) {
    const resp= await this.repository.getEt0ByInterval(START,END)
    return resp
  }
}
export {
  GetEtoByIntervalUseCase,
};
